/**
 * El ultimo influencer consultado, para que el informe pueda leerlo desde otra ruta.
 *
 * `InfluencerSearchView` guarda el resultado en estado LOCAL y ahi se queda bien: el flujo
 * de polling es suyo y no gana nada moviendolo. Pero `/influencers/informe` es otra ruta y
 * necesita el mismo objeto, asi que se publica tambien aqui.
 *
 * Redux y no sessionStorage: la respuesta trae ~184 puntos de historico y ~21 posts con sus
 * pies de foto, y serializar eso en cada busqueda para deserializarlo al abrir el informe es
 * trabajo a cambio de nada. Si el usuario recarga la pagina del informe, la ruta redirige a
 * la busqueda, que es el comportamiento correcto: sin lookup no hay informe.
 */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { InfluencerLookupPollResponse, InfluencerSocialType } from '@/types/influencer.types';

interface InfluencerState {
  lastResult: InfluencerLookupPollResponse | null;
  lastQuery: string | null;
  lastSocialType: InfluencerSocialType | null;
}

const initialState: InfluencerState = {
  lastResult: null,
  lastQuery: null,
  lastSocialType: null,
};

const influencerSlice = createSlice({
  name: 'influencer',
  initialState,
  reducers: {
    setInfluencerResult(
      state,
      action: PayloadAction<{
        result: InfluencerLookupPollResponse;
        query: string;
        socialType: InfluencerSocialType;
      }>
    ) {
      state.lastResult = action.payload.result;
      state.lastQuery = action.payload.query;
      state.lastSocialType = action.payload.socialType;
    },
    clearInfluencerResult(state) {
      state.lastResult = null;
      state.lastQuery = null;
      state.lastSocialType = null;
    },
  },
});

export const { setInfluencerResult, clearInfluencerResult } = influencerSlice.actions;
export default influencerSlice.reducer;
